<template>
  <div class="common-profile" :class="[size, inline ? 'inline' : '', fill ? 'fill' : '']" @click="onClickProfile">
    <div class="common-profile__avatar-wrap">
      <ui-image class="common-profile__image"
                :src="image"></ui-image>
      <ui-image v-if="medal && medal.img_url"
                class="common-profile__medal-img"
                :src="medal.img_url"></ui-image>
    </div>
    <div class="common-profile__name-wrap" v-if="showName">
      <p class="common-profile__name" :class="nameClass">
        {{ name }}
      </p>
      <ui-icon class="common-profile__icon" :src="icon.nioIcon" v-if="nioIcon"></ui-icon>
    </div>
  </div>
</template>

<script>
/*
 * 用户头像
 */
import Icon from '@/components/ui/Icon';
import UiImage from '@/components/ui/Image';
import {nioJsBridge} from 'nioJsBridge';

const defaultImage = require('@/assets/images/default/picture_faces_empty.png');
const nioIcon = require('@/assets/images/icon/icon_nio_26.png');

export default {
  name: 'Profile',
  components: {
    'ui-icon': Icon,
    'ui-image': UiImage
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: defaultImage
    },
    medal: {
      type: Object,
      default: () => {
      }
    },
    nioIcon: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    // 是否展示name
    showName: {
      type: Boolean,
      default: true
    },
    // 是否并列同行显示
    inline: {
      type: Boolean,
      default: false
    },
    // 撑满容器
    fill: {
      type: Boolean,
      default: false
    },
    // 自定义class
    nameClass: {
      type: String
    },
    id:{
      type: String
    }
  },
  data(){
    return {
      icon: {
        nioIcon
      }
    };
  },
  methods:{
    onClickProfile(){
      if (!this.id){
        return;
      }
      const userInfo = nioJsBridge.getUserInfo();

      if (userInfo){
        const {data} = userInfo;

        if (!data || !data.access_token){
          nioJsBridge.openURL('nioapp://user/requirelogin');
        } else {
          nioJsBridge.openURL(`nioapp://user/homepage?account_id=${this.id}`);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/mixins";
@import "../../assets/scss/standard";

.common-profile {
  width: sizeTrans(80);

  &__avatar-wrap {
    position: relative;
    width: sizeTrans(80);
    height: sizeTrans(80);
  }

  &__image {
    border-radius: 50%;
    overflow: hidden;
  }

  &__medal-img {
    &.ui-image {
      width: sizeTrans(15);
      height: sizeTrans(15);
    }

    position: absolute;
    right: 0;
    bottom: 0;
  }

  &__name-wrap {
    display: flex;
    align-items: center;
  }

  &__name {
    width: 100%;
    color: $color_mb1_front;
    @include font_tips_s();
    @include ellipsis(1);
    word-break: break-all;
  }

  &__icon {
    width: sizeTrans(26);
  }

  // size css
  &.small {
    width: sizeTrans(40);

    .common-profile__avatar-wrap {
      width: sizeTrans(40);
      height: sizeTrans(40);
    }
  }

  &.mini {
    width: sizeTrans(20);

    .common-profile__avatar-wrap {
      width: sizeTrans(20);
      height: sizeTrans(20);
    }

    .common-profile__medal-img {
      width: sizeTrans(8);
      height: sizeTrans(8);
    }
  }

  // layout css
  &.inline {
    width: 100%;
    display: flex;
    align-items: center;

    .common-profile__avatar-wrap {
      min-width: sizeTrans(80);
      max-width: sizeTrans(80);
    }

    .common-profile__name {
      flex: 1 1 auto;
      padding: 0 sizeTrans($space_5) 0 sizeTrans($space_10);
      color: $color_mb1_front;
      @include font_text_m();
    }

    &.small {
      .common-profile__avatar-wrap {
        min-width: sizeTrans(40);
        max-width: sizeTrans(40);
      }
    }

    &.mini {
      .common-profile__avatar-wrap {
        min-width: sizeTrans(20);
        max-width: sizeTrans(20);
      }
    }
  }

  &.fill {
    width: 100%;

    .common-profile__avatar-wrap {
      margin: 0 auto;
    }
  }
}
</style>